import { Component, OnDestroy } from "@angular/core";
import { ConfigurationService } from "@/shared-module/services";
import { SubSink } from "subsink";

import { Configuration } from "@/shared-module/models";

@Component({
  selector: "app-footer",
  templateUrl: "footer.component.html",
})
export class FooterComponent implements OnDestroy {
  subs = new SubSink();
  cssColor: string;
  logoImage: string;
  simulationFullName: string;

  constructor(private configurationService: ConfigurationService) {
    const thisObject = this;
    this.subs.sink = this.configurationService.config.subscribe(
      (c: Configuration) => {
        thisObject.cssColor = c.cssColor;
        if (c.highContrast) {
          thisObject.logoImage = `img/arrow-up-${c.cssColor}-hc.svg`;
        } else {
          thisObject.logoImage = `img/arrow-up-${c.cssColor}.svg`;
        }
        this.simulationFullName = c.simulationFullName;
      },
    );
  }

  onClick($event) {
    this.scrollToTop();
  }

  scrollToTop() {
    (function smoothscroll() {
      const currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
        document.getElementById("top_link").focus();
      }
    })();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
